// extracted by mini-css-extract-plugin
export default {"topContainerV2Wrapper":"topContainerV2_topContainerV2Wrapper__ts68M","topContainerV2":"topContainerV2_topContainerV2__fbAQt","hiddenTab":"topContainerV2_hiddenTab__Mdf+3"};